var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDesign = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Design-Tool-Wireframe--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Design Tool Wireframe Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.06 20.13a0.25 0.25 0 0 0 -0.42 0.13L11 23.4a0.51 0.51 0 0 0 0.14 0.45 0.47 0.47 0 0 0 0.35 0.15h0.1l3.14 -0.63a0.24 0.24 0 0 0 0.19 -0.17 0.23 0.23 0 0 0 -0.06 -0.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.23 11.77a2.61 2.61 0 0 0 -3.7 0L13 18.27a0.48 0.48 0 0 0 0 0.7l3 3a0.48 0.48 0 0 0 0.7 0l6.51 -6.5a2.61 2.61 0 0 0 0.02 -3.7Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 3.5h10.5s0.5 0 0.5 0.5v3.5s0 0.5 -0.5 0.5H4s-0.5 0 -0.5 -0.5V4s0 -0.5 0.5 -0.5",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12 9.5H4a0.5 0.5 0 0 0 -0.5 0.5v6a0.5 0.5 0 0 0 0.5 0.5h5.84a0.5 0.5 0 0 0 0.48 -0.64l-1.72 -6a0.5 0.5 0 0 0 -0.48 -0.36Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.43 16.5a0.57 0.57 0 0 0 0.41 -0.17l1.87 -1.87a1 1 0 0 0 0.29 -0.7V10a0.5 0.5 0 0 0 -0.5 -0.5h-3.84a0.5 0.5 0 0 0 -0.48 0.64l1.7 5.94a0.58 0.58 0 0 0 0.55 0.42Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.58 18H2.5a0.5 0.5 0 0 1 -0.5 -0.5v-15a0.5 0.5 0 0 1 0.5 -0.5H16a0.5 0.5 0 0 1 0.5 0.5v9.57a0.25 0.25 0 0 0 0.16 0.23 0.25 0.25 0 0 0 0.27 -0.06L18.21 11a1.05 1.05 0 0 0 0.29 -0.71V2a2 2 0 0 0 -2 -2H2a2 2 0 0 0 -2 2v16a2 2 0 0 0 2 2h7.75a0.5 0.5 0 0 0 0.49 -0.4l0 -0.24a2 2 0 0 1 0.48 -0.95 0.23 0.23 0 0 0 0 -0.26 0.24 0.24 0 0 0 -0.14 -0.15Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDesign);
export default ForwardRef;